define("shared/modifiers/call-after-hover", ["exports", "@ember/object", "@glimmer/tracking", "ember-modifier"], function (_exports, _object, _tracking, _emberModifier) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"@ember/object",0,"@glimmer/tracking",0,"ember-modifier"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  /**
   *
   * @class CallAfterHoverModifier
   * @extends Modifier
   *
   * This modifier calls the given method after an element has
   * been hovered on for a minimum duration of time
   *
   * Positional Parameters:
   * @param {Method} methodToCall The method to execute after the hover event
   *
   * Named Parameters:
   * @param {Number} minimumHoverTimeInMs The minimum duration of the hover for the event to be called
   *
   * Examples:
   *
   * Simple Usage:
   *
   * ```
   * <div {{call-after-hover @actionInstance minimumHoverTimeInMs=1}}>
   * </div>
   *
   * Note: Automatically uses a default minimumHoverTimeInMs if the parameter is not passed.
   * Note: Does not throw error an error if methodToCall is not provided. Instead, modifier will not execute.
   * ```
   */
  let CallAfterHoverModifier = _exports.default = (_class = class CallAfterHoverModifier extends _emberModifier.default {
    constructor() {
      super(...arguments);
      _defineProperty(this, "DEFAULT_MINIMUM_HOVER_TIME_IN_MS", 5000);
      _initializerDefineProperty(this, "hoverStartTimeInMs", _descriptor, this);
    }
    get minimumHoverTimeInMs() {
      return this.args.named?.minimumHoverTimeInMs || this.DEFAULT_MINIMUM_HOVER_TIME_IN_MS;
    }
    get passedParams() {
      return this.args.positional.slice(1);
    }
    get methodToCall() {
      return this.args.positional[0];
    }
    handleMouseEnter() {
      this.hoverStartTimeInMs = Date.now();
    }
    handleMouseLeave() {
      if (this.hoverStartTimeInMs && Date.now() - this.hoverStartTimeInMs >= this.minimumHoverTimeInMs) {
        this.methodToCall(this.passedParams);
      } else {
        this.hoverStartTimeInMs = null;
      }
    }
    didReceiveArguments() {
      if (this.args.positional[0] && typeof this.args.positional[0] === 'function') {
        this.removeEventListener();
        this.addEventListener();
      }
    }
    willRemove() {
      this.removeEventListener();
    }
    addEventListener() {
      this.element.addEventListener('mouseenter', this.handleMouseEnter);
      this.element.addEventListener('mouseleave', this.handleMouseLeave);
    }
    removeEventListener() {
      this.element.removeEventListener('mouseenter', this.handleMouseEnter);
      this.element.removeEventListener('mouseleave', this.handleMouseLeave);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "hoverStartTimeInMs", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "handleMouseEnter", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleMouseEnter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleMouseLeave", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleMouseLeave"), _class.prototype)), _class);
});